/**
 * CategoryNav — refined category tabs for community discovery.
 */

import React from 'react';
import { motion } from 'framer-motion';
import { LayoutGrid, Sparkles, Users, PenTool, BookOpen, BookMarked, Heart, MessageCircle } from 'lucide-react';
import { cx } from '@/components/site/primitives';
import { CATEGORIES } from './constants/seedData';

const ICONS = {
  All: LayoutGrid, Genres: Sparkles, 'Reading Clubs': Users, Writing: PenTool,
  Comics: BookOpen, Classics: BookMarked, Fandoms: Heart, 'Book Discussions': MessageCircle,
};

export default function CategoryNav({ activeCategory, onChange, trailing }) {
  return (
    <nav className="u-container mt-10 flex items-center gap-3 border-b border-line" role="tablist" aria-label="Community categories">
      <div className="scrollbar-none -mx-1 flex flex-1 snap-x items-center gap-1 overflow-x-auto px-1">
        {CATEGORIES.map(category => {
          const Icon = ICONS[category] ?? Sparkles;
          const isActive = activeCategory === category;
          return (
            <button
              key={category}
              type="button"
              role="tab"
              aria-selected={isActive}
              onClick={() => onChange(category)}
              className={cx(
                'group relative flex shrink-0 snap-start items-center gap-1.5 whitespace-nowrap px-3.5 py-2.5 text-sm font-medium transition-colors duration-200',
                isActive ? 'text-coral' : 'text-subtle hover:text-ink'
              )}
            >
              <Icon className={cx('h-4 w-4', isActive ? 'text-coral' : 'text-subtle group-hover:text-ink')} />
              {category}
              {isActive && (
                <motion.span
                  layoutId="community-category-underline"
                  className="absolute -bottom-px left-2 right-2 h-[2.5px] rounded-full bg-coral"
                  transition={{ type: 'spring', stiffness: 420, damping: 34 }}
                />
              )}
            </button>
          );
        })}
      </div>
      {trailing && <div className="mb-2 shrink-0">{trailing}</div>}
    </nav>
  );
}
